import { client } from "utils";

export const getUsersRequest = () => client.get("users");

export const switchTenantRequest = (tenant) => client.get(`user/switch-tenant/${tenant}`);
